import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  obtenerEstudiantesMatriculados,
  exportarEstudiantesMatriculados,
} from "../../../redux/solicitudesAdmSlice";
import { OrderTable } from "../../../Components/OrderTable";
import { ObtenerTodos } from "../../../redux/periodosSlice";
import { obtenerUsuariosGeneral } from "../../../redux/usuariosSlice";
import { toast } from "react-toastify";
import { useLocale } from "../../../i18n/localeContext";
import { getAdminRAdmissionPage } from "../../../Api/content";
import { Skeleton } from "antd";

export default function EstudiantesMatriculados(props) {
  const dispatch = useDispatch();
  let filtroAnio = useRef();
  const [periodoId, setPeriodoId] = useState(null);
  const [estadoId, setEstadoId] = useState(0);
  const [usuarios, setUsuarios] = useState([]);
  const [atendidoPor, setAtendidoPor] = useState(0);
  const [fechaDesde, setFechaDesde] = useState(new Date(null).toISOString());
  const [fechaHasta, setFechaHasta] = useState(new Date().toISOString());
  const [anio, setAnio] = useState(null);
  const [periodos, setPeriodos] = useState([]);
  const [estudiantesMatriculados, setEstudiantesMatriculados] = useState([]);
  const { locale } = useLocale();
  const [adminReportAdmissionPage, setAdminReportAdmissionPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const columns = [
    { label: "EstudianteId", accessor: "estudianteId", sortable: true },
    { label: "PersonaId", accessor: "dni", sortable: true },
    { label: "Nombres", accessor: "nombres", sortable: true },
    { label: "Carrera", accessor: "carrera", sortable: true },
    { label: "Periodo", accessor: "periodo", sortable: true },
    { label: "Año", accessor: "anio", sortable: true },
    { label: "Teléfono", accessor: "telefono", sortable: true },
    {
      label: "Correo institucional",
      accessor: "correoInstitucional",
      sortable: true,
    },
    { label: "Correo personal", accessor: "correoPersonal", sortable: true },
    { label: "Pais", accessor: "paisNombre", sortable: true },
    { label: "Provincia", accessor: "provinciaNombre", sortable: true },
    { label: "Cantón", accessor: "cantonNombre", sortable: true },
    { label: "Distrito", accessor: "distritoNombre", sortable: true },
    { label: "Atendido por", accessor: "atendidoPor", sortable: true },
    { label: "Fecha", accessor: "fecha", sortable: true },
    { label: "Estado", accessor: "estadoEstudiante", sortable: true },
    { label: "Fecha de nacimiento", accessor: "fechaNacimiento", sortable: true },
    { label: "Genero", accessor: "genero", sortable: true },
    { label: "¿Cómo financiará sus estudios?", accessor: "financiamientoNombre", sortable: true },
    { label: "Trabaja", accessor: "tieneTrabajo", sortable: true },
    { label: "Trabajo en sector informática", accessor: "trabajaEnSectorInformatica", sortable: true },
    { label: "Empresa", accessor: "empresaTrabajoNombre", sortable: true },
    { label: "Ocupación", accessor: "trabajoOcupacion", sortable: true },
    { label: "Pais de la empresa", accessor: "paisEmpresa", sortable: true },
    { label: "Pais", accessor: "paisEstudioSecundario", sortable: true },
    { label: "Estado de estudio", accessor: "estudioEstado", sortable: true },
    { label: "Centro educativo", accessor: "centroEducativo", sortable: true },
    { label: "Titulo obtenido", accessor: "tituloObtenidoEstudioSecundario", sortable: true },
    { label: "Año de conclusión", accessor: "fechaConclusionEstudioSecundario", sortable: true },
  ];

  const cambiarAnio = (e) => {
    let object = { anio: e.target.value, periodoNombre: null };
    cargarPeriodosPorAnio(object);
    setAnio(e.target.value);
  };
  const cargarPeriodosPorAnio = (a) => {
    let object = { anio: a.anio, periodoNombre: null };
    dispatch(ObtenerTodos(object)).then((d) => {
      setPeriodos(d.payload);
    });
  };
  const cargarUsuarios = () => {
    dispatch(obtenerUsuariosGeneral()).then((d) => {
      if (Array.isArray(d.payload)) setUsuarios(d.payload);
    });
  };

  const cambiarPeriodo = (e) => {
    setPeriodoId(e.target.value);
  };

  const cambiarEstado = (e) => {
    setEstadoId(e.target.value);
  };
  const cambiarAtendidoPor = (e) => {
    setAtendidoPor(e.target.value);
  };
  const cambiarFechaDesde = (e) => {
    setFechaDesde(e.target.value);
  };
  const cambiarFechaHasta = (e) => {
    setFechaHasta(e.target.value);
  };

  const descargarEstudiantesMatriculados = async () => {
    if (periodoId != null && anio != null && estadoId != null) {
      const { payload } = await dispatch(
        exportarEstudiantesMatriculados({
          periodoId: periodoId,
          anio: anio,
          estadoId: estadoId,
          fechaDesde,
          fechaHasta,
          atendidoPor,
        })
      );
    } else {
      toast.error("Faltan parametros por completar");
    }
  };

  useEffect(() => {
    if (periodoId != null && anio != null && estadoId != null) {
      dispatch(
        obtenerEstudiantesMatriculados({
          periodoId,
          anio,
          estadoId,
          fechaDesde,
          fechaHasta,
          atendidoPor,
        })
      ).then((d) => {
        setEstudiantesMatriculados(d.payload);
      });
    }
  }, [periodoId, anio, estadoId, fechaDesde, fechaHasta, atendidoPor]);

  useEffect(() => {
    if(usuarios.length===0)
    cargarUsuarios();
  }, [usuarios]);

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminRAdmissionPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminReportAdmissionPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminReportAdmissionPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  if (isLoadingContent) {
    return (
      <main className="main-admin">
        <div className="main-admin-bar">
          <Skeleton.Input style={{ width: 300, height: 30 }} active />
          <div className="select-filter-section-ml-auto"></div>
          <div className="header-admin-bar-items-long ml-auto">
            <div>
              <Skeleton.Input style={{ width: 80, height: 20 }} active />
              <Skeleton.Input style={{ width: 100, height: 40 }} active />
            </div>
            <div>
              <Skeleton.Input style={{ width: 80, height: 20 }} active />
              <Skeleton.Input style={{ width: 100, height: 40 }} active />
            </div>
            <div>
              <Skeleton.Input style={{ width: 80, height: 20 }} active />
              <Skeleton.Input style={{ width: 100, height: 40 }} active />
            </div>
            <div>
              <Skeleton.Input style={{ width: 100, height: 20 }} active />
              <Skeleton.Input style={{ width: 120, height: 40 }} active />
            </div>
            <div>
              <Skeleton.Input style={{ width: 60, height: 20 }} active />
              <Skeleton.Input style={{ width: 120, height: 40 }} active />
            </div>
            <div>
              <Skeleton.Input style={{ width: 60, height: 20 }} active />
              <Skeleton.Input style={{ width: 120, height: 40 }} active />
            </div>
          </div>
          <Skeleton.Button style={{ width: 40, height: 40 }} active />
        </div>
        <div className="table-container">
          <Skeleton.Input style={{ width: '100%', height: 400, minWidth: '800px' }} active />
        </div>
      </main>
    );
  }

  return (
    <main className="main-admin">
      <div className="main-admin-bar">
        <h2>{adminReportAdmissionPage?.title || "Estudiantes matriculados"}</h2>
        <div className="select-filter-section-ml-auto"></div>
        <div className="header-admin-bar-items-long ml-auto">
          <div>
            <label>{adminReportAdmissionPage?.year || "Año"}</label>

            <select ref={filtroAnio} onChange={cambiarAnio}>
              <option value={0}>{adminReportAdmissionPage?.select_option || "Seleccione"}</option>

              {new Array(40).fill(0).map((b, i) => (
                <option key={i} value={new Date().getFullYear()+1 - i}>
                  {new Date().getFullYear()+1 - i}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>{adminReportAdmissionPage?.period || "Periodo"}</label>

            <select onChange={cambiarPeriodo}>
              <option value={null}>{adminReportAdmissionPage?.select_option || "Seleccione"}</option>

              {periodos?.map((item, i) => (
                <option key={i} value={item.periodoId}>
                  {item.periodoNombre}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>{adminReportAdmissionPage?.status_admission || "Estado"}</label>
            <select onChange={cambiarEstado} defaultValue={estadoId}>
              <option value="0">{adminReportAdmissionPage?.show_all || "Mostrar todos"}</option>
              <option value="1">{adminReportAdmissionPage?.enrolled || "Matriculados"}</option>
              <option value="2">{adminReportAdmissionPage?.unenrolled || "No matriculados"}</option>
            </select>
          </div>

          <div>
            <label>{adminReportAdmissionPage?.handledby || "Atendido por"}</label>
            <select onChange={cambiarAtendidoPor} defaultValue={atendidoPor}>
              <option value={0}>{adminReportAdmissionPage?.show_all || "Mostrar todos"}</option>
              {usuarios
                ?.filter((us) => us.roles.find((rol) => rol.rolId === 3))
                .map((item, i) => (
                  <option key={i} value={item.usuarioId}>
                    {item.nombreCompleto}
                  </option>
                ))}
            </select>
          </div>

          <div>
            <label>{adminReportAdmissionPage?.from || "Desde"}</label>
            <input
              type="date"
              defaultValue={fechaDesde}
              onChange={cambiarFechaDesde}
            />
          </div>

          <div>
            <label>{adminReportAdmissionPage?.from_to || "Hasta"}</label>
            <input
              type="date"
              defaultValue={fechaHasta}
              onChange={cambiarFechaHasta}
            />
          </div>
        </div>

        <button
          className="search-button"
          title="Exportar a excel"
          onClick={descargarEstudiantesMatriculados}
        >
          <i className="material-icons-outlined"></i>
        </button>
      </div>

      <div className="table-container">
        {estudiantesMatriculados?.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={estudiantesMatriculados}
              clase="table-adm"
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>
    </main>
  );
}
